/**
 * Funzioni API per la vista CVE globale (aggregation-service, E9 / RF-11).
 * Usano createServiceClient('aggregation') come da pattern slice 1.
 */

import { createServiceClient } from '../../api/client.js';
import type { CveDetail, GlobalCveEntry } from './types.js';

/** Client parzialmente applicato per l'aggregation-service. */
const aggregationApi = createServiceClient('aggregation');

/**
 * Recupera la lista globale di tutte le CVE rilevate sul parco prodotti/release.
 * GET /cve
 * Ritorna array vuoto se non ci sono snapshot.
 */
export function fetchGlobalCves(): Promise<GlobalCveEntry[]> {
  return aggregationApi<GlobalCveEntry[]>('/cve');
}

/**
 * Recupera il dettaglio di una CVE con elenco release affette e stato VEX per-release.
 * GET /cve/:cveId
 * Lancia ApiError 404 se la CVE non compare in alcuno snapshot.
 */
export function fetchCveDetail(cveId: string): Promise<CveDetail> {
  return aggregationApi<CveDetail>(`/cve/${encodeURIComponent(cveId)}`);
}
